export default __webpack_public_path__ + "static/feature-user-sessions@2x-09e067ab6aa557e4e3903d6a7d86ac1c.png";